import { useCallback, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import React, { forwardRef, useMemo } from "react";
import Select from "react-select";

export const 
CustomDataTable = ({
  columns,
  data,
  pagination = true,
  paginationServer = false, 
  paginationTotalRows = 0, 
  paginationPerPage = 5,
  paginationRowsPerPageOptions = [5, 10, 15, 20],
  onChangePage, 
  onChangeRowsPerPage, 
  progressPending = false, 
  customStyles,
  onRowSelect,
  onRowClick,
  expandableComponent = null,
  expandableRows = false,
  conditionalRowStyles = [],
  select = true,
  singleSelect = false, // <-- NEW PROP
  fixedHeader = false, // <-- add this
  fixedHeaderScrollHeight = '300px',
}) => {
  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowSelected = (selected) => {
    const row = singleSelect ? selected.selectedRows[0] || null : selected.selectedRows || [];

    setSelectedRow(row);
    if (onRowSelect) {
      onRowSelect(row);
    }
    // console.log('Selected row(s):', row);
  };
  const handleRowClicked = (row,event) => {
    if (onRowClick) {
      // console.log('Row clicked:', event);
      onRowClick(row,event);
    }
  }
  const defaultStyles = {
    header: {
      style: {
        backgroundColor: '#1a568e33',
        color: '#ffffff',
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#6fd6ffff',
        color: 'black',
        fontFamily: 'Nunito, sans-serif',
        fontWeight: '500',
        fontSize: '16px',
        justifyContent: 'center', // Center horizontally
        textAlign: 'center',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '28px',
        justifyContent: 'center', // Center horizontally
        textAlign: 'center',
      },
    },
    // pagination: {
    //   style: {
    //     display: "flex",
    //     justifyContent: "space-between", // divide 3 sections evenly
    //     alignItems: "center",
    //     padding: "12px 24px",
    //     gap: "185px",
    //     fontSize: "14px",
    //     flexWrap: "wrap", // for responsiveness
    //   },
    //   pageButtonsStyle: {
    //     borderRadius: "4px",
    //     height: "32px",
    //     width: "32px",
    //     padding: "0px",
    //     margin: "0 2px",
    //     cursor: "pointer",
    //   },
    // },
  };
  const sortedData = Array.isArray(data) ? data : []; 
        // Custom Sort Icon Component 
        const CustomSortIcon = ({ sortDirection }) => { 
          const isSorted = sortDirection !== 'none' && sortDirection !== null; 
          return ( 
          <svg 
          width="16" 
          height="16" 
          viewBox="0 0 20 20" 
          fill="none" 
          style={{ 
            marginLeft: '6px', 
            transform: sortDirection === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)', 
            transition: 'transform 0.2s ease', 
            verticalAlign: 'middle', 
            display: 'inline-block' }} > 
          <path d="M5 7.5L10 12.5L15 7.5" 
          stroke={isSorted ? '#000' : '#666'} 
          strokeWidth="2" strokeLinecap="round" 
          strokeLinejoin="round" 
          opacity={isSorted ? 1 : 0.5} /> 
          </svg> ); }; 

  return (
    <>
    <style> 
      {`.table-striped .rdt_TableCol__sortable .rdt_TableCol_Sortable > 
        span { 
          display: none !important; 
          }`
        } 
    </style>
    <DataTable
      className="table table-striped"
      columns={columns}
      data={sortedData}
      sortIcon={<CustomSortIcon />} 
      paginationServer={paginationServer} 
      paginationTotalRows={paginationTotalRows}
      pagination={pagination}
      paginationPerPage={paginationPerPage}
      paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      onChangePage={onChangePage} 
      onChangeRowsPerPage={onChangeRowsPerPage} 
      progressPending={progressPending} 
      customStyles={customStyles || defaultStyles}
      selectableRows={select}
      selectableRowsSingle={singleSelect} // 👈 use based on prop
      onSelectedRowsChange={handleRowSelected}
      expandableRows={expandableRows}
      expandableRowsComponent={expandableComponent}
      conditionalRowStyles={conditionalRowStyles}
      highlightOnHover
      striped
      pointerOnHover
      fixedHeader={fixedHeader} // ✅ THIS
      fixedHeaderScrollHeight={fixedHeaderScrollHeight} // ✅ AND THIS
      onRowClicked={handleRowClicked}
    />
  </>
  );
};
// ..........................................................................
export const filterData = (data, searchTerm, filterKeys) => {
  if (!searchTerm) return data; // Return all data if no search term

  return data.filter((item) =>
    filterKeys.some((key) => {
      // Check for nested keys
      const value = key.includes('.') ? key.split('.').reduce((acc, part) => acc && acc[part], item) : item[key];

      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (typeof value === 'number') {
        return value.toString().includes(searchTerm);
      }

      return false;
    })
  );
};
//............................................................................

export const CustomSelect = forwardRef(({ value, onChange, placeholder, data }, ref) => {
  const options = useMemo(
    () => data.map(item => ({ value: item.value, label: item.label })),
    [data]
  );

  const defaultStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid #00ABEF' : '1px solid #d6d6d6',
      boxShadow: 'none',
      minHeight: 32,
      borderRadius: 6,
      cursor: 'pointer',
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? '#00ABEF' : isFocused ? '#c7efff' : 'transparent',
      color: isSelected ? 'white' : '#222222',
      cursor: 'pointer',
      ':active': { backgroundColor: isSelected ? '#00ABEF' : '#c7efff' }
    }),
    singleValue: (base) => ({ ...base, color: '#222' }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 }),
  };

  return (
    <Select
      ref={ref}
      value={options.find(opt => opt.value === value) || null}
      onChange={selected => onChange({ target: { value: selected?.value } })}
      options={options}
      placeholder={placeholder}
      styles={defaultStyles}
      menuPortalTarget={document.body}
      isSearchable
    />
  );
});
//----------------------------------------------------------------------------------------------------
export const useFetchDataById = (url, token, params = {}, fetchContent) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);
  const fetchTriggerRef = useRef(0);

  const buildQueryString = (params) => {
    return new URLSearchParams(
      Object.entries(params).filter(([_, v]) => v !== undefined && v !== null && v !== "")
    ).toString();
  };

  const fetchData = useCallback(async (queryParams, signal) => {
    // ✅ Skip ONLY if URL is invalid
    if (!url) {
      console.log("Skipping API call — URL is null or undefined");
      setData([]);
      setError(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    // Clear data immediately when params change to prevent showing stale data
    // This prevents race conditions where old requests complete after new ones
    // Components should handle empty data during loading state
    setData([]);

    const queryString = buildQueryString(queryParams || {});
    const apiUrl = queryString ? `${url}?${queryString}` : url;
    console.log("Fetching data from:", apiUrl);

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        signal, // Pass signal to cancel request if component unmounts or params change
      });

      // Check if request was aborted
      if (signal.aborted) {
        console.log("Request was aborted:", apiUrl);
        return;
      }

      if (response.ok) {
        const result = await response.json();
        console.log("API Response:", result);

        // Check if request was aborted after response
        if (signal.aborted) {
          console.log("Request was aborted after response:", apiUrl);
          return;
        }

        // Check if response contains an error field (some APIs return errors with 200 OK)
        if (result && typeof result === 'object' && result.error) {
          console.error("API returned error in response:", result.error);
          setError(result.error || "Error in API response");
          setData([]);
          return;
        }

        if (Array.isArray(result)) {
          setData(result);
        } else if (result?.billingPatients && Array.isArray(result.billingPatients)) {
          setData(result.billingPatients);
        } else if (result?.content && Array.isArray(result.content)) {
          setData(result.content);
        } else if (result?.sections && Array.isArray(result.sections)) {
          setData(result);
        } else {
          setData([result]);
        }
      } else {
        // Check if request was aborted
        if (signal.aborted) {
          console.log("Request was aborted:", apiUrl);
          return;
        }

        const result = await response.json();
        console.error("Failed to fetch:", response.status);
        setError(` ${result.error || response.status}`);
        setData([]);
      }
    } catch (err) {
      // Ignore abort errors
      if (err.name === 'AbortError') {
        console.log("Request was aborted:", apiUrl);
        return;
      }
      console.error("Error fetching:", err);
      // Only set error if request wasn't aborted
      if (!signal.aborted) {
        setError("Error fetching data");
        setData([]);
      }
    } finally {
      // Only update loading state if request wasn't aborted
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  }, [url, token]);

  useEffect(() => {
    // Abort previous request if it exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new AbortController for this request
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    const signal = abortController.signal;

    // 🔥 Now fetchData will ALWAYS trigger (even if params empty)
    fetchData(params, signal);

    // Cleanup: abort request when component unmounts or dependencies change
    return () => {
      abortController.abort();
    };
  }, [url, JSON.stringify(params), fetchContent, fetchData]);

  // Refetch function that triggers a new fetch
  const refetch = useCallback(() => {
    fetchTriggerRef.current += 1;
    // Abort previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // Create new AbortController
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    fetchData(params, abortController.signal);
  }, [params, fetchData]);

  return {
    data,
    loading,
    error,
    refetch,
  };
};
